export const CBRE_FLOW_ADD_INSTRUMENT_GET_ALL_LOOKUPS_SUCCESS =
  'CBRE-FLOW-ADD-INSTRUMENT/GET_ALL_LOOKUPS_SUCCESS';
export const CBRE_FLOW_ADD_INSTRUMENT_GET_ALL_LOOKUPS_FAILURE =
  'CBRE-FLOW-ADD-INSTRUMENT/GET_ALL_LOOKUPS_FAILURE';
export const CBRE_FLOW_ADD_INSTRUMENT_SUCCESS_COUNT =
  'CBRE-FLOW-ADD-INSTRUMENT/SUCCESS_COUNT';
export const MODULE = 'cbre-pjm-admin-root-details';
export const CBRE_FLOW_NEW_WORK_REQUEST_SUCCESS_COUNT =
  'CBRE_FLOW_NEW_WORK_REQUEST_SUCCESS_COUNT';